import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {setNFBottomOperatorBar} from '@/utils/tools'

// 设置底部操作栏

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let {setBottomHandle} = setNFBottomOperatorBar()
setBottomHandle()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})